import { Pipe, PipeTransform } from '@angular/core';
import { OrganisationsTyp } from 'src/app/domain/model/organisationsTyp';

@Pipe({
    name: 'anleitungOrgTypeReadable',
    standalone: false,
})
export class AnleitungOrgTypeReadablePipe implements PipeTransform {

    transform(orgaType: OrganisationsTyp, short = true): string {
        switch (orgaType) {
            case OrganisationsTyp.VNB:
                return 'Westnetz-Admin & Westnetz-Beobachter';
            case OrganisationsTyp.UENB:
                return 'Übertragungsnetzbetreiber';
            case OrganisationsTyp.NVNB_NICHTINTEGRIERT:
            case OrganisationsTyp.NVNB_TEILINTEGRIERT:
            case OrganisationsTyp.NVNB_VOLLINTEGRIERT:
                if (short) {
                    return 'Nachgelagerte Verteilnetzbetreiber';
                } else {
                    return 'Nicht-, Voll- und Teil-Integrierte Netzbetreiber';
                }

            default:
                return 'Unbekannter Organisationstyp';
        }
    }

}
